import { List, Set } from 'immutable';
import { signOutAction } from '@/domain/env/envActions';
import * as T from '@/domain/textract/actions';
import { JournalFactory, JournalSettingsFactory } from '@/domain/journal/helper';

import * as A from '@/domain/journal/actions';
import get from 'lodash/get';

export const reducer = {
  journal(state = JournalFactory(), action) {
    switch (action.type) {
      // need this to reset MatchedLines JE field at least
      // check this for consistency as it was commented out previously
      case A.clearJournalEntryAction.type:
        return JournalFactory();

      case A.setLoadingAction.type:
        return state.set('loading', true);

      case A.endLoadingAction.type:
        return state.set('loading', false);

      case A.setEditingAction.type:
        return state.set('editing', true);

      case A.endEditingAction.type:
        return state.set('editing', false);

      case A.getJournalEntryAction.type:
      case A.getJournalEntryAction.success:
      case A.getJournalEntryForGridAction.success:
      case A.updateJournalEntryAction.success:
      case A.updateJEFromInsightsAction.success:
        return state.merge(
          action.payload.setIn(['paginationList'], state.paginationList).set('editing', state.editing),
        );

      case A.getJournalEntryPageAction.success:
        return state.merge(
          action.payload
            .update('entry', (e) => state.entry.merge(e))
            .update('line_items', (l) => state.line_items.concat(l))
            .update('lines', (l) => state.lines.concat(l))
            .set('selectedRow', state.selectedRow),
        );

      case signOutAction.success:
      case A.getJournalEntryAction.failure:
        return JournalFactory().set('errorFromErp', get(action.err, 'response.data'));

      case A.updateJournalEntryAction.type:
        return state.setIn(['entry', action.payload.item._cell, 'cellSet'], action.payload.item.cellSet);

      case A.selectRowAction.type:
        return state.set('selectedRow', action.payload);

      case A.selectUnmatchedLinesAction.type: {
        return state.set('selectedRow', action.payload);
      }

      case A.getJEListAction.type: {
        return action.payload.isNewList
          ? state.setIn(['paginationList', 'list'], new List()).set('pageToken', null)
          : state;
      }

      case A.getJEListAction.success:
        return state.updateIn(['paginationList'], (e) => {
          const { list, pageToken, isNewList, include_id: includeId, preload } = action.payload;

          return preload
            ? e.update('cachedList', (cl) => (includeId ? cl.set(includeId, list) : cl))
            : e
                .update('list', (l) => (isNewList ? list : l.concat(list)))
                .set('pageToken', pageToken)
                .update('cachedList', (cl) => (includeId ? cl.set(includeId, list) : cl));
        });

      case A.updateCurrentPaginationListAction.type:
        return state.updateIn(['paginationList'], (pl) => {
          const { list, pageToken = null, isNewList = true } = action.payload;
          return pl.update('list', (l) => (isNewList ? list : l.concat(list))).set('pageToken', pageToken);
        });

      case A.clearJEMessagesAction.type:
        return state.set('messages', new List());

      case T.toggle2WayMatchingForDocumentAction.type:
        // reset selected rows when toggling 2-way matching as we consider it another mode of working with document
        return state.set('selectedRow', new Set());

      default:
        return state;
    }
  },
  journalSettings(state = JournalSettingsFactory(), { type, payload }) {
    switch (type) {
      case A.getJournalSettingsOrderedColsAction.success:
      case A.updateJournalSettingsOrderedColsAction.success:
        return state.set('orderedCols', payload);

      case A.getJournalSettingsPinnedColsAction.success:
      case A.updateJournalSettingsPinnedColsAction.success:
        return state.set('pinnedCols', payload);

      case A.getJELineColumnsVisibilityAction.success:
      case A.updateJELineColumnsVisibilityAction.success:
        return state.set('disabledCols', payload);
      default:
        return state;
    }
  },
};
